export default "__VITE_ASSET__Dxyis0BL__"